import React from "react";
import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Collapse,
  Divider,
  FormControlLabel,
  FormGroup,
  Stack,
  TextField,
} from "@mui/material";

export default function ProfileTaxCard({
  open,
  onToggle,
  profileData,
  fieldErrors,
  taxIdError,
  economicIdError,
  vatError,
  onInputChange,
}) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
        mb: 3,
      }}
    >
      <CardHeader
        title="Steuerliche Einstellungen"
        subheader="Steuernummer, USt-IdNr., Methoden"
        action={onToggle()}
      />
      <Collapse in={open} timeout="auto">
        <Divider />
        <CardContent>
          <Stack spacing={2}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} flexWrap={{ sm: "wrap" }}>
              <TextField
                label="Steuernummer"
                value={profileData.taxId || ""}
                onChange={(event) => onInputChange("taxId", event.target.value)}
                placeholder="z. B. 12/345/67890"
                error={Boolean(fieldErrors.taxId || taxIdError)}
                helperText={fieldErrors.taxId || taxIdError || ""}
                sx={{ flex: 1, minWidth: 240 }}
                fullWidth
              />
              <TextField
                label="Wirtschafts-ID"
                value={profileData.economicId || ""}
                onChange={(event) => onInputChange("economicId", event.target.value)}
                placeholder="z. B. DE123456789-00001"
                error={Boolean(fieldErrors.economicId || economicIdError)}
                helperText={fieldErrors.economicId || economicIdError || ""}
                sx={{ flex: 1, minWidth: 240 }}
                fullWidth
              />
              <TextField
                label="Umsatzsteuer-ID"
                value={profileData.vat || ""}
                onChange={(event) => onInputChange("vat", event.target.value)}
                placeholder="z. B. DE123456789"
                error={Boolean(fieldErrors.vat || vatError)}
                helperText={fieldErrors.vat || vatError || ""}
                sx={{ flex: 1, minWidth: 240 }}
                fullWidth
              />
            </Stack>

            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!profileData.kleinunternehmer}
                    onChange={(event) => onInputChange("kleinunternehmer", event.target.checked)}
                  />
                }
                label="Kleinunternehmer (Paragraf 19 UStG - es wird keine Umsatzsteuer ausgewiesen)"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!profileData.istVersteuerung}
                    onChange={(event) => onInputChange("istVersteuerung", event.target.checked)}
                    disabled={!!profileData.kleinunternehmer}
                  />
                }
                label="Ist-Versteuerung (Umsatzsteuer erst bei Zahlung faellig)"
              />
            </FormGroup>

            <Alert severity="info" variant="outlined">
              Diese Einstellungen wirken sich unmittelbar auf Rechnungen, Vorschau und Auswertungen aus.
            </Alert>
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  );
}
